<app-modal [open]="active" [name]="'accept-offered-proposal'" (close)="closeDialog()">
  <div modal-header>{{ multiple ? "Accept All Work Assignments?" : "Accept Work Assignment?" }}</div>
  <div modal-body>
    <div>
      {{
        multiple
          ? "By clicking “Accept All,” you will be accepting " +
            numberOfAcceptedProposals +
            " work assignment(s)" +
            (scopeLabel ? " " + scopeLabel : "") +
            "."
          : "By clicking “Accept”, you will be accepting the assignment."
      }}
      <br /><br />
      Do you wish to continue?
    </div>
    <!-- Itemized confirmation, the same list Submit All Quotes shows. Bulk
         only: the single-accept hosts pass no `siteDetails`. -->
    <app-bulk-item-list
      *ngIf="multiple && siteDetails?.length"
      [rows]="siteDetails!"
      testIdPrefix="accept-offered-proposal"
      listLabel="Offers to accept"
      [turnTimeFallback]="false"
    ></app-bulk-item-list>
    <requirements-acknowledgement
      #reqAck
      [projectRequirements]="data?.specialQuoteRequirements"
      [siteRequirements]="data?.sites?.[0]?.site?.specialSiteCondition"
      [showSite]="!multiple"
      [hasSiteRequirements]="multiple ? hasAnySiteRequirements : null">
    </requirements-acknowledgement>
    <div class="accept-offered-proposal-dialog__summary">
      <div *ngIf="multiple; else single" class="accept-offered-proposal-dialog__summary-item">
        <p class="accept-offered-proposal-dialog__summary-label">Project</p>
        <p class="accept-offered-proposal-dialog__summary-value">
          {{ "Project ID: " + (data?.projectOrderId ?? "") }}
        </p>
      </div>
      <ng-template #single>
        <div class="accept-offered-proposal-dialog__summary-item">
          <p class="accept-offered-proposal-dialog__summary-label">Service Type</p>
          <p class="accept-offered-proposal-dialog__summary-value">
            {{ siteSubType ? siteType + " - " + siteSubType : siteType }}
          </p>
        </div>
        <div class="accept-offered-proposal-dialog__summary-item">
          <p class="accept-offered-proposal-dialog__summary-label">Location</p>
          <p class="accept-offered-proposal-dialog__summary-value">
            <span *ngIf="address?.streetAddress"
              >{{ address?.streetAddress }}<br /></span
            >{{ address?.cityStateZip }}
          </p>
        </div>
      </ng-template>
    </div>
  </div>
  <button
    modal-footer
    type="button"
    class="btn btn--primary"
    data-testid="accept-offered-proposal-confirm"
    (click)="acceptOffer()"
    [disabled]="isSubmitting || (reqAck?.requiresAcknowledgement && !reqAck?.acknowledged)"
  >
    {{ multiple ? "Accept All" : "Accept" }}
  </button>
  <button
    modal-footer
    type="button"
    class="btn btn--secondary"
    data-testid="accept-offered-proposal-cancel"
    (click)="closeDialog()"
  >
    Cancel
  </button>
</app-modal>
